var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "popover",
      attrs: {
        placement: "bottom-start",
        trigger: "focus",
        "visible-arrow": false,
        width: "240",
        "popper-class": "myPopover",
      },
      on: { show: _vm.focus, hide: _vm.blur },
    },
    [
      _c(
        "div",
        { staticClass: "menu" },
        [
          _c(
            "el-scrollbar",
            { ref: "scrollbar", attrs: { wrapStyle: "max-height:350px;" } },
            [
              _vm.isSearch
                ? [
                    _c(
                      "ul",
                      { staticClass: "menus" },
                      _vm._l(_vm.searchArr, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "options",
                            class: { selected: item.checked },
                            on: {
                              click: function ($event) {
                                return _vm.handleSelect(item)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("span", [_vm._v(_vm._s(item.label))]),
                              item.checked
                                ? _c("i", { staticClass: "el-icon-check" })
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    !_vm.searchArr.length
                      ? _c("div", { staticClass: "nodata" }, [
                          _vm._v("无匹配数据"),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear", mode: "in-out" } },
                [
                  !_vm.isSearch
                    ? [
                        _c(
                          "ul",
                          { staticClass: "menus" },
                          _vm._l(_vm.copyOptions, function (item, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass: "options",
                                class: { selected: item.checked },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSelect(item)
                                  },
                                },
                              },
                              [
                                _c("div", [
                                  _c("span", [_vm._v(_vm._s(item.label))]),
                                  item.checked
                                    ? _c("i", { staticClass: "el-icon-check" })
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "condition-name",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c("tag-input", {
            ref: "tagInput",
            staticClass: "tagInput",
            class: { "error-border": _vm.error },
            attrs: { placeholder: _vm.placeholder, allowEnter: false },
            on: {
              afterAdd: _vm.afterAdd,
              getFocus: _vm.getFocus,
              change: _vm.inputSearch,
              deleteTag: _vm.deleteTag,
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }